// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"66cb16561a1a3a7fa4f3","454":"8bcbc22c2d6aef25cdf1"}[chunkId] + ".js";
};